export const environment = {
  production: false,
  apiUrl: 'https://cmgsvcgdocsbulkexportapiappuat01.azurewebsites.net',
  msalConfig: {
    auth: {
      clientId: '65a235ae-1ea4-4ea7-b4c7-f4d006a20dd2',
      authority:
        'https://login.microsoftonline.com/57d88166-f247-4dee-a6f9-e6359f96ff2c',
    },
    apiScope: 'api://e2f8ca23-8e54-44a1-8708-2d20956332ed/adminapiscope',
    graphScope: 'user.read',
    graphUri: 'https://graph.microsoft.com/v1.0/',
  },
  enablePhase2: true,
  defaultServiceProviderGuid: '6f85a78e-f7c6-4fb4-9789-52fc16d71e3f',
};
